module.exports = __webpack_public_path__ + "img/app-biz.934c8fc4.png";